module.exports = __webpack_public_path__ + "static/media/iot-consultation01.8beaac06.jpg";